export default "__VITE_ASSET__2dbc0331__"